import ModalForm from "./Form";
import ModalFormContinue from "./FormContinue";
import { LIST_PACKAGES,CLC_CALENDAR, DATATABLE_EXPORT } from "../../../../Config/ApiUrl";

export const Schema = {
    components: { ModalForm,ModalFormContinue },

    data() {
        return {
            DATATABLE_EXPORT,
            isAddEditModalActive: false,
            isEditContinueModalActive: false,
            deleteConfirmationModalActive: false,
            deleteLoader: false,
            selectedUrl: this.ENDPOINT,
            tableId: "LIST_PACKAGES-table",
            rowData: {},
            formId: "LIST_PACKAGES-form",
            formIdContinue: "LIST_PACKAGES-form-continue",
            tableColumns: [
                {
                    title: "Semester",
                    type: "custom-html",
                    key: "academic_calendar",
                    isVisible: true,
                    modifier: (value) => {
                        return value ? value.academic_calendar_name : '-'
                    },
                },
                {
                    title: "Packages Name",
                    type: "text",
                    key: "package_name",
                },
                {
                    title: "Product Name",
                    type: "custom-html",
                    key: "product",
                    isVisible: true,
                    modifier: (value) => {
                        return value ? value.name : '-'
                    },
                },
                {
                    title: "Product Category",
                    type: "custom-html",
                    key: "product_category",
                    isVisible: true,
                    modifier: (value) => {
                        return value ? value.name : '-'
                    },
                },
                {
                    title: "Teaching Type",
                    type: "custom-html",
                    key: "teaching_type",
                    isVisible: true,
                    modifier: (value) => {
                        return value ? value.teaching_type_desc : '-'
                    },
                },
                {
                    title: "Student Care",
                    type: "custom-html",
                    key: "student_care",
                    isVisible: true,
                    modifier: (value) => {
                        return value ? value.full_name : '-'
                    },
                },
                {
                    title: "Academic Advisor",
                    type: "custom-html",
                    key: "academic_advisor",
                    isVisible: true,
                    modifier: (value) => {
                        return value ? value.full_name : '-'
                    },
                },
                {
                    title: "Course",
                    type: "custom-html",
                    key: "course_list_packages",
                    modifier: (value) => {
                        if (!Array.isArray(value) || value.length === 0) return "-";

                        return value
                            .map(item => item.course?.course_name)
                            .filter(Boolean) 
                            .join(", ");
                    },
                },
                {

					title: "Action",
					type: "custom-html",
					key: "id",
					modifier: (value, rowData) => {
              
						var buttonAction = '';
                        buttonAction = `<button 
                                class="btn btn-success " 
                                data-bs-toggle="tooltip" 
                                title="Continue"
                                style="border-radius: 15px !important; padding: 0.4rem 0.5rem;font-size:11px;margin-right: 3px;"
                                onclick="window.Handlecontinue(${rowData.id},'`+rowData.package_name+`','`+rowData.product.name+`')"
                            >
                                Continue <i class="fas fa-angle-double-right"></i>
                            </button>`;
                        
                        buttonAction += `<button 
                                class="btn btn-success " 
                                data-bs-toggle="tooltip" 
                                title="Edit"
                                style="border-radius: 15px !important; padding: 0.4rem 0.5rem;margin-right: 3px;"
                                onclick="window.Handleedit(${rowData.id})"
                            >
                                <i class="fa fa-edit"></i>
                            </button>`;
                        buttonAction += `<button 
                                class="btn btn-success " 
                                data-bs-toggle="tooltip" 
                                title="Delete"
                                style="border-radius: 15px !important; padding: 0.4rem 0.5rem;"
                                onclick="window.Handledelete(${rowData.id})"
                            >
                                <i class="fa fa-trash"></i>
                            </button>`;
                        return buttonAction;
                    }
                }
            ],
            ENDPOINT: LIST_PACKAGES,
            actionObj: {
                title: this.$t("action"),
                type: "action",
            },
            options: {
                name: "LIST_PACKAGES",
                url: LIST_PACKAGES,
                showHeader: true,
                enableHighlights: true,
                // enableRowSelect: true,
                enableSaveFilter: true,
                columns: [],
                actions: [
                ],
                filters: [],
                showFilter: true,
                showSearch: true,
                showCount: true,
                showClearFilter: true,
                paginationType: "pagination",
                responsive: true,
                rowLimit: 10,
                showAction: true,
                orderBy: "desc",
                actionType: "default",
            },
        };
    },
    mounted() {
        window.addEventListener('academicCalendarChanged', (e) => {
            this.updateAcademicFilter(e.detail.id);
        });
    },
    methods: {
        updateAcademicFilter(id) {
            this.options.url = `${this.ENDPOINT}?semester=${id}`;
            
            if (this.$hub) {
                this.$hub.$emit(`reload-${this.tableId}`);
            }
        },
        /**
         * Delete confirmed $emit Form confirmation modal
         */
        onDelete() {
            let url = `${this.ENDPOINT}/${this.selectedId}`;
            this.deleteLoader = true;
            this.axiosDelete(url)
                .then((response) => {
                    this.deleteLoader = false;
                    $("#demo-delete").modal("hide");
                    this.onCancelDelete();
                    this.$toastr.s(response.data.message);
                    // this.searchAndSelectFilterOptions();
                })
                .catch(({ err }) => {})
                .finally(() => this.$hub.$emit(`reload-${this.tableId}`));
        },
        onCancelDelete() {
            this.deleteConfirmationModalActive = false;
            this.reSetData();
        },
        reSetData() {
            this.rowData = {};
            this.selectedUrl = "";
        },
    },
};
